type ThrottleError = {
  message?: string;
  body?: {message?: string} | null;
};

function parseThrottleWaitSeconds(message?: string): number | null {
  if (!message) return null;

  const match = /(\d+)\s*second/i.exec(message);
  if (!match) return null;

  const seconds = Number(match[1]);
  return Number.isFinite(seconds) && seconds > 0 ? seconds : null;
}

function getThrottleWaitSeconds(error: unknown): number | null {
  const throttleError = error as ThrottleError | undefined;

  return (
    parseThrottleWaitSeconds(throttleError?.body?.message) ??
    parseThrottleWaitSeconds(throttleError?.message)
  );
}

export {parseThrottleWaitSeconds, getThrottleWaitSeconds};
